/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'

const Dashboard: FC = () => {
  return (
    <>
    </>
  )
}

export { Dashboard }
